module.exports = __webpack_public_path__ + "img/map-pin.1d395ee2.svg";